import PropTypes from 'prop-types';
import React from 'react';

function withLink(WrappedComponent) {
  const Container = ({ url, className, 'data-testid': testId, ...props }) =>
    url ? (
      <a href={url} data-testid={testId} className={className}>
        <WrappedComponent {...props} />
      </a>
    ) : (
      <WrappedComponent {...props} />
    );

  Container.propTypes = {
    url: PropTypes.string,
    className: PropTypes.string,
    'data-testid': PropTypes.string,
  };

  return Container;
}

export default withLink;
